import Ticker from './ticker.model.js';

export default class OptionsChain {
  underlying;
  tickerList;

  chain = new Map();

  constructor(underlying, symbolList = []) {
    this.underlying = underlying;

    this.tickerList = symbolList.map((symbol) => {
      const ticker = new Ticker(symbol, underlying);
      const expiration = ticker.expirationDateString;

      if (!this.chain.has(expiration)) this.chain.set(expiration, new Set());
      this.chain.get(expiration).add(ticker.strike);

      return ticker;
    });
  }

  get expirations() {
    return Array.from(this.chain.keys()).sort();
  }

  strikesByExpiration(expiration) {
    if (!expiration) return [];
    return Array.from(this.chain.get(expiration)).sort((a, b) => parseInt(a) - parseInt(b));
  }

  filteredOptions(expiration, strike) {
    return this.tickerList
      .filter((ticker) => ticker.expirationDateString === expiration && `${ticker.strike}` === `${strike}`)
      .sort((a) => (a.isCall ? -1 : 1));
  }
}
